export default "__VITE_ASSET__34f0b5c0__"